import { render } from "./Balita.vue?vue&type=template&id=0da92a2e&scoped=true"
import script from "./Balita.vue?vue&type=script&lang=js"
export * from "./Balita.vue?vue&type=script&lang=js"

import "./Balita.vue?vue&type=style&index=0&id=0da92a2e&scoped=true&lang=css"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da92a2e"]])

export default __exports__